import {BACKEND_ENDPOINT, NOTIFICATION_ENDPOINT} from '../../Constants'
import axiosInstance from '../../config/AxiosConfig'

export function getUserListForConversation(
    userId,
    filterRequest = {},
    rows,
    dto = false,
    sortField = 'id',
    sortOrder = -1,
) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/user/getUserListForConversation`,
            filterRequest,
            {
                params: {userId, rows, dto, sortField, sortOrder},
            },
        )
        .then(res => res.data)
        .catch(error => console.log(error))
}

export function getRoomById(userId, roomId) {
    return axiosInstance
        .get(`${NOTIFICATION_ENDPOINT}/room/getById`, {
            params: {userId, roomId},
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}
